// API配置文件
// 根据环境自动选择后端地址

const getApiConfig = () => {
  // 开发环境使用本地地址
  if (process.env.NODE_ENV === 'development') {
    return {
      baseURL: 'https://aichatco.cljc.vip',
      wsURL: 'wss://aichatco.cljc.vip'
    }
  }
  
  // 生产环境使用服务器地址
  return {
    baseURL: 'https://aichatco.cljc.vip',
    wsURL: 'wss://aichatco.cljc.vip'
  }
}

const apiConfig = getApiConfig()

export default apiConfig

// 导出具体的URL
export const API_BASE_URL = apiConfig.baseURL
export const WS_BASE_URL = apiConfig.wsURL

// 导出完整的API端点
export const API_ENDPOINTS = {
  // 认证相关
  LOGIN: `${apiConfig.baseURL}/api/auth/login`,
  REGISTER: `${apiConfig.baseURL}/api/auth/register`,
  CHANGE_PASSWORD: `${apiConfig.baseURL}/api/auth/change-password`,
  VALIDATE_TOKEN: `${apiConfig.baseURL}/api/auth/validate-token`,
  
  // 聊天相关
  CHAT_WS: `${apiConfig.wsURL}/chat`,
  
  // 其他API端点可以在这里添加
}
